import axios from "axios";
import config from './config';
const TOKEN_KEY = 'token';
const INFO_KEY = "info";
const USER_ID_KEY = "uid";

const getToken = function() {
  let token = config.token;
  if(!token) {
    console.log('Read token from storage.');
    token = getStorage(TOKEN_KEY);
    config.token = token;
  }
  //判断token是否过期 过期返回null
  if(token && Date.now() - token.timestamp > 59 * 60 * 1000) {
    token = null;
  }
  return token;
};

const setToken = function(token) {
  let temp = {
    timestamp: Date.now(),
    token: token.token,
    subscribe: token.subscribe
  };
  config.token = temp;
  config.uid = token.user.id;
  config.info = token.user;
  localStorage.setItem(TOKEN_KEY, JSON.stringify(temp));
  localStorage.setItem(INFO_KEY, JSON.stringify(token.user));
  localStorage.setItem(USER_ID_KEY, token.user.id);
};


const setStorageInfo = function (info) {
  config.info = info;
  localStorage.setItem(INFO_KEY, JSON.stringify(info));
}



const getUserId = function () {
  return config.uid || localStorage.getItem(USER_ID_KEY);
}

const getStorage = function(key) {
  let result = null;
  let storage = localStorage.getItem(key);
  try {
    storage = JSON.parse(storage);
    result = storage;
  } catch (e) {
    console.log(`Storage for ${key} parse failed.`);
  }
  return result;
};

const cleanToken = function() {
  localStorage.clear();
  config.token = null;
  config.uid = null;
  config.info = null;
};

const getInfo = function (fn, force) {
  let info = config.info || getStorage(INFO_KEY);
  if(info && !force) {
    config.info = info;
    typeof fn === 'function' && fn(config.info);
  } else {
    axios({
      url: '/user/' + getUserId(),
      method: 'GET'
    }).then(res => {
      config.info = res;
      localStorage.setItem(INFO_KEY, JSON.stringify(res));
      typeof fn === 'function' && fn(res);
    });
  }
}


export { getToken, getStorage, setToken, cleanToken, getInfo, getUserId, setStorageInfo }
